var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Header',{attrs:{"title":'SureLock',"links":_vm.links}}),_c('div',{attrs:{"id":"surelock-content"}},[_c('PreservationRecordList',{attrs:{"rows":_vm.rows}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }